import CommonIFrame from '../atoms/CommonIFrame';

const TradePerformance = () => {
    return (
        <CommonIFrame
            src="https://id-preview--a4af9760-bb0a-4872-932a-24c32ca7bc22.lovable.app/"
            title="Trade Performance"
        />
    );
};

export default TradePerformance;
